import { StatsAdapterInterface } from '../../../stats/adapter.interface';

export class Snowplow2StatsAdapterRoom implements StatsAdapterInterface {
  /**
   *
   * @param room
   */
  constructor(protected room: string) {}

  /**
   * @inheritDoc
   */
  public getData(): number {
    if (this.room === 'studio') {
      return 0;
    }

    const room = parseInt(this.room, 10);

    return isNaN(room) ? 0 : room;
  }
}
